import { render } from "./MfittBooking1.vue?vue&type=template&id=13c68325"
import script from "./MfittBooking1.vue?vue&type=script&lang=js"
export * from "./MfittBooking1.vue?vue&type=script&lang=js"
script.render = render

export default script